/* eslint-disable react-hooks/exhaustive-deps */
import Icon from "@components/general/Icon";
import Label from "@components/general/Label";
import { getAirport } from "@utilize/Format";
import { FC, useContext, useRef } from "react";
import { ParticipateContext } from "./index";

export const Route: FC = () => {

    const flightRouteRef = useRef<HTMLDivElement>(null);
    const { participate } = useContext(ParticipateContext);


    return (

        <div className="flight-survey-route flex flex-center justify-between">
            <div ref={flightRouteRef} className="flight-route">
                <span className="origin">{getAirport(participate.origin).cityName}</span>
                <Icon name="icon-airplane-landing" flipRtl size="30px" />
                <span className="destination">{getAirport(participate.destination).cityName}</span>
            </div>
            <Label
                mode="inline"
                dir="ltr"
                icon="icon-account"
                size="xlarge"
                text={`${participate.firstName} ${participate.lastName}`}
                fontWeight="bold"
            />
        </div>

    )
}